import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionReportRoutingModule } from './transaction-report-routing.module';
import { RetailersRoutingModule } from '../retailers/retailers-routing.module';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ControlsModule, FormFieldModule } from 'src/app/shared';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TransactionReportComponent } from './transaction-report.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    TransactionReportComponent
  ],
  imports: [
    CommonModule,
    TransactionReportRoutingModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    FormsModule,
    FormFieldModule,
    ControlsModule,
    NgbModule,
    ReusableModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    BsDropdownModule.forRoot(),
    MatSelectModule
  ]
})
export class TransactionReportModule { }
